import React, { CSSProperties } from "react";
import styles from "./panel.module.scss";

const PanelBlock = ({
  visible,
  active,
  focused,
  testId,
  children,
}: React.PropsWithChildren<{
  visible?: boolean | null;
  active?: boolean | null;
  focused?: boolean | null;
  testId?: string;
}>): JSX.Element => {
  const style: CSSProperties = {};
  if (visible === false) {
    style.display = "none";
  }
  return (
    <div
      data-testid={testId}
      className={`${styles.panel_block} ${active === undefined || active === null || active === false ? "" : styles.is_active} ${focused ? styles.is_focused : ""}`}
      style={style}
    >
      {children}
    </div>
  );
};

PanelBlock.displayName = "PanelBlock";
export { PanelBlock };
